document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".recipe-picker").forEach((picker) => {
    const required = parseInt(picker.dataset.required || "4", 10);
    const boxes = [...picker.querySelectorAll(".recipe-picker__checkbox")];
    const status = picker.querySelector(".recipe-picker__status");

    const form = picker.closest("form");
    if (!form) return;

    const addBtn =
      form.querySelector('button[name="add"]') ||
      form.querySelector('button[type="submit"]');

    const update = () => {
      const checked = boxes.filter((b) => b.checked);
      const count = checked.length;

      // Disable unchecked boxes when max reached
      boxes.forEach((b) => {
        if (!b.checked) b.disabled = count >= required;
      });

      if (status) status.textContent = `${count}/${required}`;

      if (addBtn) addBtn.disabled = count !== required;
    };

    boxes.forEach((b) => b.addEventListener("change", update));
    update();
  });
});
